async function getHyperpayCheckoutId() {
    const url = "https://eu-test.oppwa.com/v1/checkouts";
    const data = new URLSearchParams();
    data.append("entityId", "8a8294174d0595bb014d05d829cb01cd");
    data.append("amount", "92.00");
    data.append("currency", "SAR");
    data.append("paymentType", "DB");
    data.append("integrity", "true");

    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Authorization": "Bearer OGE4Mjk0MTc0ZDA1OTViYjAxNGQwNWQ4MjllNzAxZDF8OVRuSlBjMm45aA==",
            "Content-Type": "application/x-www-form-urlencoded"
        },
        body: data
    });

    const result = await response.json();
    console.log(result);
    return result;
}

// Call the function when needed
getHyperpayCheckoutId().then(data => {
    if (data.id) {
        console.log("Checkout ID:", data.id);
        console.log("Integrity Value:", data.integrity);
        // You can now use these values in your script
    }
});
